import React, { useState } from 'react';

// Renders long user-entered text preserving line breaks (shift-enter), with a
// Show more / Show less toggle so cards stay compact on mobile.
const ExpandableText = ({ text, className = '', charLimit = 280, lineLimit = 4 }) => {
  const [expanded, setExpanded] = useState(false);
  if (!text) return null;
  const lines = String(text).split('\n');
  const isLong = text.length > charLimit || lines.length > lineLimit;
  let shown = text;
  if (isLong && !expanded) {
    shown = lines.slice(0, lineLimit).join('\n');
    if (shown.length > charLimit) shown = shown.slice(0, charLimit);
  }
  return (
    <div className={className}>
      <div className="whitespace-pre-wrap break-words">
        {shown}
        {isLong && !expanded ? '…' : ''}
      </div>
      {isLong && (
        <button
          type="button"
          className="text-xs font-medium text-blue-600 hover:underline mt-1"
          onClick={() => setExpanded((v) => !v)}
          data-testid="expandable-text-toggle"
        >
          {expanded ? 'Show less ▴' : 'Show more ▾'}
        </button>
      )}
    </div>
  );
};

export default ExpandableText;
